export default __webpack_public_path__ + "static/media/patner2.16130e8f.svg";